import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "form-empty"
}
const _hoisted_3 = { class: "action" }
const _hoisted_4 = { class: "action-title" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "infos" }
const _hoisted_7 = { class: "line" }
const _hoisted_8 = { class: "line" }
const _hoisted_9 = { class: "line" }
const _hoisted_10 = { class: "line" }
const _hoisted_11 = {
  key: 1,
  class: "line"
}
const _hoisted_12 = { class: "actions" }

import { ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import {
  analysisMethodList,
  analysisMethodCreate,
  analysisMethodDelete,
} from "@/common/api/rest/analysis/method";

import type { AnalysisType } from "@/common/types/analysis";

import { searchMethodItem } from "@/components";

import {
  svgIcon,
  baseModal,
  baseConfirm,
  baseTooltip,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'method',
  props: {
    data: {},
    width: { default: "100%" },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const methods = ref<any[]>([]);

const selected = ref<any>(null);
const inputSearch = ref("");

const showModalAdd = ref(false);
const showDelConfirm = ref(false);

function fetchData() {
  if (!props.data) return;

  analysisMethodList(props.data.account_id, {
    analysis_id: props.data.analysis_id,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        methods.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function add() {
  showModalAdd.value = true;
}

function addSelect(data: any) {
  selected.value = data;
}

function addCancel() {
  inputSearch.value = "";
  selected.value = null;
  showModalAdd.value = false;
}

function addConfirm() {
  if (!props.data || !selected.value) return;

  analysisMethodCreate(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    analysis_id: props.data.analysis_id,
    group_id: selected.value.group_id,
    method_id: selected.value.method_id,
    method_name: selected.value.code,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        addCancel();
        fetchData();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function del(method: any) {
  selected.value = method;
  showDelConfirm.value = true;
}

function delCancel() {
  selected.value = null;
  showDelConfirm.value = false;
}

function delConfirm() {
  if (!props.data || !selected.value) return;

  analysisMethodDelete(props.data.account_id, selected.value.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        delCancel();
        fetchData();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

watchEffect(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tab-component", { width: __props.width }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (methods.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)("analysis.texts.empty_method")), 1))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(methods.value, (method, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "item"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, " Método " + _toDisplayString(index + 1), 1),
                (__props.isEdit)
                  ? (_openBlock(), _createBlock(_unref(baseTooltip), {
                      key: 0,
                      position: "relative"
                    }, {
                      trigger: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-none btn-sm remove",
                          onClick: ($event: any) => (del(method))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "trash",
                            size: "1.75rem"
                          })
                        ], 8, _hoisted_5)
                      ]),
                      tooltip: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("common.labels.delete")), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.code")) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(method?.code), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.name")) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(method?.name), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(method?.metadata, (item, method_index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: method_index }, [
                    (item.type === 'RANGE')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("label", null, _toDisplayString(item.name) + " " + _toDisplayString(_unref(t)("question.labels.minimum")) + ": ", 1),
                            _createElementVNode("span", null, _toDisplayString(item.min) + " " + _toDisplayString(item.measure), 1)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("label", null, _toDisplayString(item.name) + " " + _toDisplayString(_unref(t)("question.labels.maximum")) + ": ", 1),
                            _createElementVNode("span", null, _toDisplayString(item.max) + " " + _toDisplayString(item.measure), 1)
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("label", null, _toDisplayString(item.name) + ": ", 1),
                          _createElementVNode("span", null, _toDisplayString(item.answer), 1)
                        ]))
                  ], 64))
                }), 128))
              ])
            ]))
          }), 128)),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          class: "btn btn-md btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (add()))
        }, _toDisplayString(_unref(t)("common.labels.add").toUpperCase()), 1)
      ])
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: 
        _unref(t)('common.labels.add', {
          concat: _unref(t)('common.labels.method'),
        }).toUpperCase()
      ,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.add'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[1] || (_cache[1] = ($event: any) => (addCancel())),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (addConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(searchMethodItem), {
          "account-id": __props.data?.account_id,
          "method-group-id": __props.data?.method_group_id,
          ids: methods.value.map((item) => item.method_id),
          onUpdateData: addSelect
        }, null, 8, ["account-id", "method-group-id", "ids"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelConfirm.value,
      "max-width": "400px",
      title: 
        _unref(t)('common.labels.remove', {
          concat: _unref(t)('common.labels.method'),
        }).toUpperCase()
      ,
      message: 
        _unref(t)('common.texts.remove_message', {
          concat: selected.value?.name,
        })
      ,
      onCancel: delCancel,
      onConfirm: delConfirm
    }, null, 8, ["show", "title", "message"])
  ], 2))
}
}

})